import { Drivers } from './drivers.model';
export class Vehicle {
  registration_number = '';
  make = '';
  model = '';
  year = '';
  weight = '';
  drivers: any = [];
  ownership = '';
  mileage: string = '';
  ncd: string = '';
  is_kept_overnight: string = '';
  postcode: string = '';
  tracker: string = '';
}
